export const SET_NOTIFICATION_LIST_DATA = "SET_NOTIFICATION_LIST_DATA";
export const SET_NOTIFICATION_LIST_PAGINATION = "SET_NOTIFICATION_LIST_PAGINATION";
export const SET_NOTIFICATION_LIST_FILTER = "SET_NOTIFICATION_LIST_FILTER";
export const SET_NOTIFICATION_VIEW_DATA = "SET_NOTIFICATION_VIEW_DATA";

export const SET_CATEGORIES_LIST_DATA = "SET_CATEGORIES_LIST_DATA";
export const SET_CATEGORIES_LIST_PAGINATION = "SET_CATEGORIES_LIST_PAGINATION";
export const SET_CATEGORIES_LIST_FILTER = "SET_CATEGORIES_LIST_FILTER";
export const SET_CATEGORIES_VIEW_DATA = "SET_CATEGORIES_VIEW_DATA";

export const RESET_NOTIFICATION_REDUCER = "RESET_NOTIFICATION_REDUCER";
